module.exports = {
      id: "tv-usage",
      viewBox: "0 0 24.014 24",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#tv",
      toString: function () {
        return this.url;
      }
    }